import React, {useEffect} from "react"
import cogoToast from "cogo-toast"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import * as handlers from "../../../_redux/selected-instrument/selectedInstrumentHandlers";
import ViewInstrumentSkeleton from "./ViewInstrumentSkeleton"
import InstrumentDetails from "./component/InstrumentDetails"

const ViewInstrument = props => {

    const selectedInstrument = useSelector(({selectedInstrument}) => {
        const data = selectedInstrument?.data?.id === props.match.params.instrumentId ? selectedInstrument.data : null;
        return  {...selectedInstrument, data};
    }, shallowEqual);

    // Redux dispatch
    const dispatch = useDispatch();

    /* Fetch Instrument Details */
    useEffect(() => {
        dispatch(handlers.fetchInstrumentDetails(props.match.params.instrumentId));
    }, [dispatch, props.match.params.instrumentId]);
      
    /* Notification Pop up */
    useEffect(() => {
        if (selectedInstrument?.notification){
            cogoToast[selectedInstrument.notification.type](selectedInstrument.notification.message);
            dispatch(handlers.clearNotification());
        }
    });
    
    return selectedInstrument?.data ?
            <InstrumentDetails instrument={selectedInstrument.data}/>
            :
            <ViewInstrumentSkeleton />
}

export default ViewInstrument;

